import BulkUploadModalModule from './containers/bulkUploadModalModule'

export {default as BulkUploadModalModuleLayout} from './components/bulkUploadModalModuleLayout'

export default BulkUploadModalModule
